var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-message',{attrs:{"color":"yellow"}},[_c('sui-message-header',[_vm._v("需要管理員權限")]),_vm._v(" 欲申請管理員權限，請聯絡管理員並提供右上角的User ID（數字） ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }